(() => {
  const initialized = new WeakSet();

  const initialize = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);

    const tabs = [...root.querySelectorAll('[data-info-tab]')];
    const panels = [...root.querySelectorAll('[data-info-panel]')];
    const accordions = [...root.querySelectorAll('[data-info-accordion]')];

    const activateTab = (name, focus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.infoTab === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.infoPanel !== name;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab.dataset.infoTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + tabs.length) % tabs.length;
        activateTab(tabs[nextIndex].dataset.infoTab, true);
      });
    });

    accordions.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        accordions.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    if (selected) activateTab(selected.dataset.infoTab);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-pdp-information]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
